import React from 'react';
import {
  TextInput,
  ReferenceInput,
  SelectInput,
  BooleanInput,
  AutocompleteInput,
} from 'react-admin';

import {
  STATUS_ATIVO,
  ESTADO_FISICO_CONGELADO,
  ESTADO_FISICO_RESFRIADO,
  ESTADO_FISICO_SECO,
} from '../../utils/constants';

const choicesEstadoFisico = [
  { id: ESTADO_FISICO_CONGELADO, name: 'Congelado' },
  { id: ESTADO_FISICO_RESFRIADO, name: 'Resfriado' },
  { id: ESTADO_FISICO_SECO, name: 'Seco' },
];

// Mesmos campos de Resources/Produtos/Filter.js, adaptados pra `advancedFilters` do
// ListPageTabbedComBuscaPagina (array de Inputs soltos, exibidos no drawer "Filtros
// avançados" em vez da barra de filtros do react-admin). "Descrição" (nome) virou a busca
// rápida do cabeçalho (`quickFilterSource`), por isso não se repete aqui.
// Simplificação conhecida: a Pasta de Fornecedor não filtra mais dinamicamente pelo
// Fornecedor selecionado no mesmo drawer (dependia do form da barra de filtro antiga) —
// revisar se fizer falta no feedback do pessoal.
// Filtros de texto/seleção primeiro, switches (BooleanInput) depois — o Drawer de filtros
// avançados (ListPageTabbedComBuscaPagina) já agrupa switches consecutivos com um
// espaçamento vertical menor entre eles (ver `agruparFiltrosPorTipo` nesse arquivo).
const advancedFilters = [
  <TextInput label="Código de barras" source="codigo" />,
  <ReferenceInput
    fullWidth
    label="Categoria"
    source="categoria_id"
    reference="categorias"
    sort={{ field: 'nome', order: 'ASC' }}
    filterToQuery={(searchText) => ({ nome: `${searchText}` })}
    perPage={30}
  >
    <AutocompleteInput optionText="nome" />
  </ReferenceInput>,
  <ReferenceInput
    fullWidth
    label="Local"
    source="local_id"
    reference="locais_setores"
    sort={{ field: 'nome', order: 'ASC' }}
    filterToQuery={(searchText) => ({ nome: `${searchText}` })}
    filter={{ status: STATUS_ATIVO }}
    perPage={30}
  >
    <AutocompleteInput optionText="nome" />
  </ReferenceInput>,
  <ReferenceInput
    fullWidth
    label="Fornecedor"
    source="fornecedor_id"
    reference="fornecedores"
    sort={{ field: 'nome', order: 'ASC' }}
    filterToQuery={(searchText) => ({ nome: `${searchText}` })}
    perPage={30}
    filter={{ status: STATUS_ATIVO }}
  >
    <AutocompleteInput optionText="nome" />
  </ReferenceInput>,
  <ReferenceInput
    source="familia_produto_id"
    reference="familias_produtos"
    label="Família"
    allowEmpty={false}
  >
    <SelectInput optionText="nome" allowEmpty={false} />
  </ReferenceInput>,
  <ReferenceInput
    label="Unidade"
    source="unidade_id"
    reference="unidades"
    allowEmpty={false}
    filter={{ status: STATUS_ATIVO }}
  >
    <SelectInput optionText="nome" allowEmpty={false} />
  </ReferenceInput>,
  <TextInput label="Descrição XML" source="descricao_pesquisa_xml" />,
  <SelectInput
    source="estado_fisico"
    choices={choicesEstadoFisico}
    label="Estado Físico"
    allowEmpty={false}
  />,
  <ReferenceInput
    fullWidth
    label="Pasta de Fornecedor"
    source="pasta_id"
    reference="pastas-fornecedores"
    sort={{ field: 'nome', order: 'ASC' }}
    filterToQuery={(searchText) => ({ nome: `${searchText}` })}
    perPage={10}
  >
    <AutocompleteInput optionText="nome" />
  </ReferenceInput>,
  <BooleanInput label="Tem código de barras" source="isCodigoBarras" />,
  <BooleanInput label="Impostos Verificados" source="is_impostos" />,
  <BooleanInput label="Incluir na pesquisa do FC" source="is_search" />,
  <BooleanInput label="Em Ruptura" source="is_ruptura" />,
  <BooleanInput label="Importado" source="importado" />,
  <BooleanInput label="Contém Lotes" source="has_lote" />,
  <BooleanInput label="Exposição Paletizada" source="is_pallet_exposicao" />,
  <BooleanInput label="Tem Caixaria de Pallet" source="tem_caixaria_pallet" />,
  <BooleanInput label="Invencível" source="is_invencivel" />,
  <BooleanInput label="Pertencente ao Mix" source="pertencente_ao_mix" />,
  <BooleanInput label="Jornal de Ofertas" source="no_jornal" />,
  <BooleanInput
    label="Os campos foram preenchidos?"
    source="is_campos_preenchido"
  />,
  <BooleanInput
    label="Foi verificado Fiscalmente"
    source="is_campos_fiscais_verificados"
  />,
];

export default advancedFilters;
